import { VendorBuyingAgreementGeneralConditionsList } from '../../../components/Vendor';

export function BuyingAgreementGeneralConditions() {
  return <VendorBuyingAgreementGeneralConditionsList />;
}
